<template>
  <a-modal
    :visible="visible"
    title="在线率查询"
    :footer="null"
    @cancel="$emit('update:visible', false)"
    width="1400px"
    :bodyStyle="{
      height: '720px'
    }"
  >
    <div style="padding-bottom: 10px">
      <a-input
        v-model="nameSearch"
        placeholder="请输入站点搜索"
        style="width: 150px"
      />
      &nbsp;&nbsp;时间范围：<a-range-picker
        v-model="timeRange"
        style="width: 200px"
        format="YYYY-MM-DD"
        :disabledDate="disabledDate"
      />
      &nbsp;&nbsp;<span>设备总数： {{ devCount }} </span> &nbsp;&nbsp;<span
        >总在线时长：{{ totalOnlineHours }}</span
      >
      &nbsp;&nbsp;<span>总在线率： {{ totalOnlineRate }}</span>
    </div>
    <a-row>
      <a-col :span="8">
        <a-table
          rowKey="station_id"
          :columns="columns"
          :data-source="seriesData"
          bordered
          :rowClassName="rowClassName"
        >
          <template slot="online_rate" slot-scope="text">
            <a-tag color="green">
              {{ text }}
            </a-tag>
          </template>
        </a-table>
      </a-col>
      <a-col :span="16">
        <div id="chart" class="chart" ref="chart"></div>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { getOnlineRate } from "@/api/api";
import { online_rate_options } from "@/options/chart";
import { online_rate_columns } from "@/options/columns";
import Highcharts from "highcharts/highstock";
import moment from "moment";
import _ from "lodash";
export default {
  data() {
    return {
      columns: online_rate_columns,
      resData: [],
      seriesData: [],
      nameSearch: "",
      timeRange: [moment().subtract(7, "days"), moment()],
      devCount: 0,
      totalOnlineHours: 0,
      totalOnlineRate: 0
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["defaultInfo"])
  },
  watch: {
    nameSearch() {
      this.handleResData();
    },
    visible(v) {
      if (v) {
        this.getOnlineRateData();
      }
    },
    timeRange() {
      this.getOnlineRateData();
    }
  },
  mounted() {
    // this.getOnlineRateData();
  },
  methods: {
    rowClassName(record, index) {
      if (index % 2 === 0) {
        return "even-tr";
      } else {
        return "odd-tr";
      }
    },
    disabledDate(current) {
      return current > moment();
    },
    async getOnlineRateData() {
      let start_time = moment(this.timeRange[0]).format("YYYY-MM-DD");
      let end_time = moment(this.timeRange[1]).format("YYYY-MM-DD");

      try {
        let res = await getOnlineRate(
          this.defaultInfo.defaultGroupId,
          start_time,
          end_time
        );
        this.resData = res.data.data;
        this.handleResData();
      } catch (error) {
        console.log(error);
      }
    },
    handleResData() {
      let total_hours = moment(this.timeRange[1]).diff(
        moment(this.timeRange[0]),
        "hours"
      );
      let data = this.resData;
      if (this.nameSearch) {
        data = data.filter(x => x.name.includes(this.nameSearch));
      }
      let seriesData = [];
      let totalOnlineHours = 0;
      data.forEach(item => {
        let curInfo = seriesData.find(x => x.station_id == item.station_id);
        if (!curInfo) {
          seriesData.push({
            hours: item.hours,
            name: item.name,
            sn: item.sn,
            station_id: item.station_id,
            data: [[moment(item.time).unix() * 1000, item.hours]]
          });
        } else {
          curInfo.hours += item.hours;
          curInfo.data.push([moment(item.time).unix() * 1000, item.hours]);
        }
        totalOnlineHours += item.hours;
      });
      seriesData.forEach(x => {
        x.online_rate = Math.round((x.hours / total_hours) * 100) + "%";
      });
      this.seriesData = seriesData;
      this.devCount = this.seriesData.length;
      this.totalOnlineHours = totalOnlineHours;
      this.totalOnlineRate = 0;
      if (this.devCount) {
        this.totalOnlineRate =
          _.round((totalOnlineHours / (total_hours * this.devCount)) * 100, 2) +
          "%";
      }
      this.drawPlot();
    },
    drawPlot() {
      let options = _.cloneDeep(online_rate_options);
      options.series = this.seriesData;
      Highcharts.stockChart("chart", options);
    }
  }
};
</script>

<style lang="less" scoped>
.chart {
  width: 100%;
  height: 650px;
}

/deep/ .even-tr {
  background-color: #f5f7fa;
}
</style>
